import script from "./Carousel.vue?vue&type=script&setup=true&lang=ts&name=Carousel"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=ts&name=Carousel"

import "./Carousel.vue?vue&type=style&index=0&id=6ec21414&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec21414"]])

export default __exports__